import { z } from "zod";
import { TicketListQuery } from "@uwu/contracts";

// [T-058] view=mentioned/snoozed + status_type มาจาก T-057 — รับไว้ก่อน แม้ contracts บน main ยังไม่มี
export const InboxSearch = TicketListQuery.pick({ view: true, team_id: true, q: true, sort: true, view_id: true }).extend({
  view: z.enum(["mine", "team_unassigned", "team_all", "watching", "all", "mentioned", "snoozed"]).optional(),
  status_type: z.string().optional(),
});
export type InboxSearch = z.infer<typeof InboxSearch>;

export function validateInboxSearch(search: Record<string, unknown>): InboxSearch {
  const r = InboxSearch.safeParse(search);
  return r.success ? r.data : { view: "mine" };
}

